<template>
    <v-row row wrap>
        <v-col cols="12">
            <v-card-actions class="d-inline text-left">
                <v-dialog class="text-left" v-model="dialog" persistent max-width="640px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn depressed color="secondary" v-bind="attrs" v-on="on">
                            <v-icon left>mdi-basket-plus</v-icon>
                            {{ $t("producto.labels.ingresar") }}
                        </v-btn>
                    </template>
                    <v-card class="product-search-dialog">
                        <v-card-title class="product-dialog-title">
                            <v-icon left color="secondary">mdi-magnify</v-icon>
                            Buscar producto
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="product-dialog-card-text">
                            <v-container class="pa-4">
                                <v-form ref="form" autocomplete="off" @submit.prevent="save">
                                    <!-- Sección: Código de barras -->
                                    <div class="search-section barcode-section">
                                        <div class="section-header">
                                            <v-icon small class="mr-1">mdi-barcode-scan</v-icon>
                                            <span class="section-title">Código de barras</span>
                                        </div>
                                        <v-row align="center" no-gutters>
                                            <v-col cols="12" sm="8" class="pr-sm-2">
                                                <v-text-field
                                                    ref="productoTextField"
                                                    name="codigo del producto"
                                                    v-model="form.idProducto"
                                                    :label="$t('movimiento.labels.idProducto')"
                                                    :placeholder="$t('movimiento.labels.idProducto')"
                                                    color="secondary"
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    autofocus
                                                    prepend-icon="mdi-barcode"
                                                    @blur="trimCodigoBarrasField"
                                                @keyup.enter="findByParamsProducto(form.idProducto)"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" class="pt-2 pt-sm-0">
                                                <v-btn
                                                    block
                                                    color="primary"
                                                    :loading="loading"
                                                    depressed
                                                    @click="findByParamsProducto(form.idProducto)"
                                                >
                                                    <v-icon left small>mdi-plus</v-icon>
                                                    Agregar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="my-4">
                                        <span class="divider-text">o</span>
                                    </v-divider>

                                    <!-- Sección: Búsqueda por texto -->
                                    <div class="search-section autocomplete-section">
                                        <div class="section-header">
                                            <v-icon small class="mr-1">mdi-text-search</v-icon>
                                            <span class="section-title">Buscar por marca o modelo</span>
                                        </div>
                                        <v-row align="center" no-gutters>
                                            <v-col cols="12" sm="8" class="pr-sm-2">
                                                <v-autocomplete
                                                    ref="productoAutocomplete"
                                                    v-model="selectedProducto"
                                                    :items="autocompleteItems"
                                                    :loading="searchLoading"
                                                    :search-input.sync="searchText"
                                                    item-text="displayText"
                                                    item-value="id"
                                                    return-object
                                                    label="Escriba para buscar..."
                                                    placeholder="Ej: Nike, Adidas, modelo..."
                                                    color="secondary"
                                                    outlined
                                                    dense
                                                    hide-details="auto"
                                                    clearable
                                                    no-filter
                                                    prepend-icon="mdi-magnify"
                                                    :menu-props="{ contentClass: 'movimiento-compra-autocomplete-menu' }"
                                                    @change="onProductoSelected"
                                                    @input="onAutocompleteInput"
                                                >
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-content class="pa-0">
                                                            <div class="autocomplete-item-wrapper">
                                                                <div class="autocomplete-left d-flex flex-column">
                                                                    <span class="font-weight-medium text-truncate">
                                                                        {{ item.nombre || `${item.marca.nombre} ${item.modelo.nombre}` }}
                                                                    </span>
                                                                    <span class="grey--text text--darken-1 text-caption">
                                                                        {{ item.marca.nombre }} {{ item.modelo.nombre }}
                                                                        <span v-if="item.tamanio && item.tamanio.tamanio">
                                                                            - {{ item.tamanio.tamanio }}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                                <span class="autocomplete-stock">Stock: {{ item.stock }}</span>
                                                            </div>
                                                        </v-list-item-content>
                                                    </template>
                                                    <template v-slot:selection="{ item }">
                                                        <span class="text-truncate">
                                                            {{ item.nombre || `${item.marca.nombre} ${item.modelo.nombre}` }}
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="4" class="pt-2 pt-sm-0">
                                                <v-btn
                                                    block
                                                    color="primary"
                                                    depressed
                                                    :disabled="!item.id || (stockDisponibleEnCard === 0 && !allowAddZeroStock)"
                                                    @click="agregarProducto"
                                                >
                                                    <v-icon left small>mdi-plus</v-icon>
                                                    Agregar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Error: producto no encontrado por código de barras -->
                                    <v-row v-if="searchError && !item.id">
                                        <v-col cols="12">
                                            <v-alert type="error" dense outlined class="search-result-alert">
                                                <v-icon left>mdi-barcode-off</v-icon>
                                                No se encontró ningún producto con ese código de barras
                                            </v-alert>
                                        </v-col>
                                    </v-row>

                                    <!-- Resultado: tarjeta del producto encontrado -->
                                    <v-row v-if="item.id" class="product-result-row mt-6">
                                        <!-- Sin stock -->
                                        <v-col cols="12" v-if="item.stock === 0">
                                            <v-card outlined class="product-result-card product-result-error">
                                                <v-card-text class="pa-4">
                                                    <div class="d-flex align-center">
                                                        <v-avatar size="48" color="error" class="mr-4 flex-shrink-0">
                                                            <v-icon color="white">mdi-alert-circle-outline</v-icon>
                                                        </v-avatar>
                                                        <div class="flex-grow-1 min-width-0">
                                                            <div class="product-result-title error--text mb-1">Producto sin stock</div>
                                                            <div v-if="item.nombre" class="product-result-nombre text-body-1 font-weight-medium mb-1">{{ item.nombre }}</div>
                                                            <div class="product-result-info">
                                                                <span class="product-result-marca">{{ item.marca.nombre }}</span>
                                                                <span class="product-result-modelo">{{ item.modelo.nombre }}</span>
                                                                <span class="product-result-tamanio">{{ (item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : null }}</span>
                                                            </div>
                                                            <div class="product-result-stock text--disabled">Stock: 0</div>
                                                            <div class="text-caption grey--text mt-1">No hay stock disponible para este producto</div>
                                                        </div>
                                                        <v-btn
                                                            v-if="allowAddZeroStock"
                                                            small
                                                            color="primary"
                                                            depressed
                                                            class="ml-3 flex-shrink-0"
                                                            @click="agregarOtroProducto"
                                                        >
                                                            <v-icon left small>mdi-plus</v-icon>
                                                            Agregar
                                                        </v-btn>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- Stock bajo / alerta -->
                                        <v-col cols="12" v-else-if="item.stockAlerta && item.stock > 0 && item.stock <= item.stockAlerta">
                                            <v-card outlined class="product-result-card product-result-warning">
                                                <v-card-text class="pa-4">
                                                    <div class="d-flex align-center">
                                                        <v-avatar size="48" color="warning" class="mr-4 flex-shrink-0">
                                                            <v-icon color="white">mdi-alert-outline</v-icon>
                                                        </v-avatar>
                                                        <div class="flex-grow-1 min-width-0">
                                                            <div class="product-result-title warning--text mb-1">Producto encontrado</div>
                                                            <div v-if="item.nombre" class="product-result-nombre text-body-1 font-weight-medium mb-1">{{ item.nombre }}</div>
                                                            <div class="product-result-info">
                                                                <span class="product-result-marca">{{ item.marca.nombre }}</span>
                                                                <span class="product-result-modelo">{{ item.modelo.nombre }}</span>
                                                                <span class="product-result-tamanio">{{ (item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : null }}</span>
                                                            </div>
                                                            <div class="product-result-stock warning--text">Stock: {{ stockDisponibleEnCard }}</div>
                                                            <div class="text-caption orange--text mt-1">Stock en nivel de alerta (máx: {{ item.stockAlerta }})</div>
                                                        </div>
                                                        <v-btn
                                                            v-if="stockDisponibleEnCard > 0"
                                                            small
                                                            color="primary"
                                                            depressed
                                                            class="ml-3 flex-shrink-0"
                                                            @click="agregarOtroProducto"
                                                        >
                                                            <v-icon left small>mdi-plus</v-icon>
                                                            Agregar otro
                                                        </v-btn>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- Stock suficiente -->
                                        <v-col cols="12" v-else>
                                            <v-card outlined class="product-result-card product-result-success">
                                                <v-card-text class="pa-4">
                                                    <div class="d-flex align-center">
                                                        <v-avatar size="48" color="success" class="mr-4 flex-shrink-0">
                                                            <v-icon color="white">mdi-check-circle-outline</v-icon>
                                                        </v-avatar>
                                                        <div class="flex-grow-1 min-width-0">
                                                            <div class="product-result-title success--text mb-1">Producto encontrado</div>
                                                            <div v-if="item.nombre" class="product-result-nombre text-body-1 font-weight-medium mb-1">{{ item.nombre }}</div>
                                                            <div class="product-result-info">
                                                                <span class="product-result-marca">{{ item.marca.nombre }}</span>
                                                                <span class="product-result-modelo">{{ item.modelo.nombre }}</span>
                                                                <span class="product-result-tamanio">{{ (item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : null }}</span>
                                                            </div>
                                                            <div class="product-result-stock success--text">Stock: {{ stockDisponibleEnCard }}</div>
                                                        </div>
                                                        <v-btn
                                                            v-if="stockDisponibleEnCard > 0"
                                                            small
                                                            color="primary"
                                                            depressed
                                                            class="ml-3 flex-shrink-0"
                                                            @click="agregarOtroProducto"
                                                        >
                                                            <v-icon left small>mdi-plus</v-icon>
                                                            Agregar otro
                                                        </v-btn>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="product-dialog-actions px-4 py-3">
                            <v-spacer></v-spacer>
                            <v-btn color="grey darken-1" text @click="closeDialog(); resetForm()">
                                <v-icon left small>mdi-close</v-icon>
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-actions>

            <div class="table-fixed-header-wrap">
            <v-data-table
                class="mt-4 product-list-table"
                fixed-header
                :height="resolvedCartTableHeight"
                item-key="id"
                :headers="headers"
                :items="items"
                :loading="loading"
                :items-per-page="-1"
                hide-default-footer
            >
                <template slot="no-data">
                    <div class="text-xs-center" v-t="'common.noData'"></div>
                </template>

                <template slot="loading">
                    <div class="text-xs-center" v-t="'common.loading'"></div>
                </template>

                <template v-slot:item.precio="{ item }">
                    <div v-if="precioEditable">
                        <div class="d-flex align-center">
                            <v-text-field
                                :value="formatPrecioInput(item.precioBase)"
                                :class="['precio-input', { 'text-decoration-line-through': item.ofertaAplicada && item.precioBase }]"
                                type="text"
                                inputmode="decimal"
                                dense
                                hide-details
                                prefix="$"
                                style="max-width: 6.5rem;"
                                @keypress="soloDecimales($event)"
                                @change="onPrecioCommit(item, $event)"
                                @blur="onPrecioCommit(item, $event)"
                                @keydown.enter="onPrecioCommit(item, $event)"
                            />
                            <v-tooltip v-if="item.precioManual" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" x-small color="orange darken-2" class="ml-1">mdi-pencil</v-icon>
                                </template>
                                <span>{{ $t('common.precioManualTooltip') }}</span>
                            </v-tooltip>
                        </div>
                        <div v-if="item.ofertaAplicada && item.precioBase != null" class="success--text font-weight-bold text-caption">
                            ${{ Number(item.precio).toFixed(2) }}
                        </div>
                    </div>
                    <div v-else-if="item.ofertaAplicada && item.precioBase">
                        <div class="text-decoration-line-through grey--text text-caption">
                            ${{ item.precioBase.toFixed(2) }}
                        </div>
                        <div class="success--text font-weight-bold">
                            ${{ item.precio.toFixed(2) }}
                        </div>
                    </div>
                    <div v-else>
                        ${{ item.precio.toFixed(2) }}
                    </div>
                </template>

                <template v-slot:item.cantidad="{ item }">
                    <div class="d-flex align-center flex-nowrap justify-center cantidad-cell">
                        <v-btn
                            icon
                            x-small
                            color="primary"
                            class="cantidad-btn-square white--text"
                            :disabled="cantidadDisabledMenos(item)"
                            @click="emitUpdateCantidad(item, (item.cantidad || 1) - 1)"
                        >
                            <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        <v-text-field
                            :value="item.cantidad || 0"
                            type="text"
                            inputmode="numeric"
                            dense
                            hide-details
                            class="cantidad-input mx-1"
                            style="max-width: 3.5rem;"
                            @keypress="soloNumeros($event)"
                            @input="onCantidadInput(item, $event)"
                            @blur="onCantidadBlur(item, $event)"
                            @keydown.enter="onCantidadBlur(item, $event)"
                        />
                        <v-btn
                            icon
                            x-small
                            color="primary"
                            class="cantidad-btn-square white--text"
                            :disabled="cantidadDisabledMas(item)"
                            @click="emitUpdateCantidad(item, (item.cantidad || 0) + 1)"
                        >
                            <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                    </div>
                </template>

                <template v-slot:item.stock="{ item }">
                    <span class="text-center d-block">{{ item.stock != null ? item.stock : 0 }}</span>
                </template>

                <template v-slot:item.oferta="{ item }">
                    <v-tooltip bottom v-if="item.ofertaAplicada">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                color="success"
                                text-color="white"
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="oferta-chip"
                            >
                                <v-icon left small>mdi-sale</v-icon>
                                {{ getOfertaDescripcion(item.ofertaAplicada) }}
                            </v-chip>
                        </template>
                        <span>
                            <strong>{{ item.ofertaAplicada.nombre }}</strong><br>
                            Ahorro: ${{ item.ofertaAplicada.descuento.toFixed(2) }}
                        </span>
                    </v-tooltip>
                    <span v-else class="grey--text text-caption">-</span>
                </template>

                <template v-slot:item.action="{ item }">
                    <delete-button @click="$emit('delete', item)" />
                </template>

            </v-data-table>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { DeleteButton } from "@dracul/common-frontend"
import { DayjsMixin } from "@dracul/dayjs-frontend";
import ProductoProvider from "../../../../producto/providers/ProductoProvider";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";


export default {
    name: "MovimientoCompraList",
    components: { DeleteButton },
    mixins: [DayjsMixin],
    props: {
        items: { type: Array },
        value: {
            type: Object,
            required: true
        },
        /** Si es true, al montar se abre el diálogo "Buscar producto". En PresupuestoPedidoForm se pasa false. */
        autoOpenSearchDialog: { type: Boolean, default: true },
        /** Si es true, el botón + de cantidad no permite superar el stock. Presupuesto: false; Pedido de venta: true. */
        limitCantidadByStock: { type: Boolean, default: true },
        /** Si es true, permite agregar productos con stock 0 (ej. presupuesto). */
        allowAddZeroStock: { type: Boolean, default: false },
        /** Oculta columna Stock (ej. orden de compra). */
        hideStockColumn: { type: Boolean, default: false },
        /** Oculta columna Oferta (ej. orden de compra). */
        hideOfertaColumn: { type: Boolean, default: false },
        /** Permite editar precio de lista (presupuesto / OV / OC). POS queda en false. */
        precioEditable: { type: Boolean, default: false },
        /**
         * Altura del cuerpo de la tabla (fixed-header). Si no se pasa, se usa vista “página” amplia.
         * En modal (ej. crear movimiento) conviene algo acotado: p. ej. min(32vh, 280px) o 260.
         */
        cartTableHeight: { type: [String, Number], default: undefined },
    },
    data() {
        return {
            // items: [],
            totalItems: null,
            loading: false,
            dialog: false,
            item: { type: Object },
            searchError: false,
            searchText: '',
            selectedProducto: null,
            autocompleteItems: [],
            searchLoading: false,
            searchTimeout: null,
            lastSearchText: '', // Mantener el último texto de búsqueda
            isProtectingText: false, // Flag para evitar loops en el watcher
            cantidadAgregadaItem: 0, // Unidades agregadas del producto mostrado en la card
            cantidadInputTimer: null,
            precioInputTimer: null,
        }
    },
    created() {
        if (this.itemsCarrito) {
            this.items = this.itemsCarrito
        }
    },
    async mounted() {
        if (this.autoOpenSearchDialog) {
            this.dialog = true;
            this.$nextTick(() => {
                this.focusProductoBarcodeFieldPreventScroll();
            });
        }
    },
    beforeDestroy() {
        clearTimeout(this.cantidadInputTimer);
        clearTimeout(this.precioInputTimer);
    },
    computed: {
        resolvedCartTableHeight() {
            const h = this.cartTableHeight;
            if (h != null && h !== '') {
                return typeof h === 'number' ? `${h}px` : String(h);
            }
            return 'calc(100vh - 420px)';
        },
        headers() {
            const h = [
                { text: this.$t('producto.labels.nombre') || 'Nombre', value: 'nombre' },
                { text: this.$t('producto.labels.precio'), value: 'precio' },
                { text: this.$t('producto.labels.cantidad'), value: 'cantidad', align: 'center' },
            ];
            if (!this.hideStockColumn) {
                h.push({ text: 'Stock real', value: 'stock', align: 'center', sortable: false });
            }
            if (!this.hideOfertaColumn) {
                h.push({ text: 'Oferta', value: 'oferta', sortable: false });
            }
            h.push({ text: this.$t('common.actions'), value: 'action', sortable: false });
            return h;
        },
        getOrderBy() {
            return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
        },
        getOrderDesc() {
            return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
        },
        form: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        },
        stockDisponibleEnCard() {
            if (!this.item || !this.item.id) return 0;
            const stock = this.item.stock || 0;
            return Math.max(0, stock - this.cantidadAgregadaItem);
        }
    },
    methods: {
        /** Evita que el navegador haga scroll del contenedor (p. ej. diálogo scrollable) al reenfocar tras agregar ítem. */
        focusProductoBarcodeFieldPreventScroll() {
            const ref = this.$refs.productoTextField;
            if (!ref) return;
            const input = ref.$refs && ref.$refs.input;
            const el = input || (ref.$el && ref.$el.querySelector && ref.$el.querySelector('input'));
            if (el && typeof el.focus === 'function') {
                try {
                    el.focus({ preventScroll: true });
                } catch (e) {
                    el.focus();
                }
            }
        },
        getPriceDisplaySync(item) {
            return (item && item.precio != null) ? item.precio.toFixed(2) : '0.00';
        },
        validate() {
            return this.$refs.form.validate()
        },
        fetch() {
            this.loading = true
            this.items = this.itemsCarrito;
            this.loading = false;
            this.$refs.list.fetch()
        },
        create() {
            this.$emit('create');
        },
        trimCodigoBarrasField() {
            if (this.form.idProducto == null || this.form.idProducto === '') return
            const t = String(this.form.idProducto).trim()
            this.form.idProducto = t === '' ? null : t
        },
        findByParamsProducto(codigoBarras) {
            const codigo = codigoBarras != null && codigoBarras !== ''
                ? String(codigoBarras).trim()
                : ''
            this.form.idProducto = codigo === '' ? null : codigo
            if (!codigo) {
                this.searchError = false
                return
            }
            this.loading = true;
            this.searchError = false;
            const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
            ProductoProvider.findByParamsProducto(codigo, depositoId).then(r => {
                    const encontrados = r.data && r.data.productoFindByParams
                        ? r.data.productoFindByParams
                        : []

                    if (encontrados.length > 0) {
                        this.cantidadAgregadaItem = 0;
                        this.item = encontrados[0];
                        this.save();
                        // Limpiar el campo de código de barras después de encontrar el producto
                        this.$nextTick(() => {
                            this.form.idProducto = null;
                            this.focusProductoBarcodeFieldPreventScroll();
                        });
                    } else {
                        this.item = {}
                        this.searchError = true
                    }
                }).catch(err => {
                    this.resetForm();
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                });
        },
        save() {
            const canAdd = this.item.id && (this.allowAddZeroStock || (this.item.stock != null && Number(this.item.stock) > 0));
            if (canAdd) {
                this.$emit('addProductToCart', { producto: this.item, cantidad: 1 });
                this.cantidadAgregadaItem += 1;
            }
        },
        agregarOtroProducto() {
            const canAdd = this.item && this.item.id && (this.allowAddZeroStock || this.stockDisponibleEnCard > 0);
            if (canAdd) {
                this.$emit('addProductToCart', { producto: this.item, cantidad: 1 });
                this.cantidadAgregadaItem += 1;
            }
        },
        resetForm() {
            this.$emit('resetForm');
            this.item = {};
            this.searchError = false;
            this.searchText = '';
            this.selectedProducto = null;
            this.autocompleteItems = [];
            this.lastSearchText = '';
            this.cantidadAgregadaItem = 0;
        },
        closeDialog() {
            this.$emit('closeDialog');
            this.dialog = false;
        },
        searchProductos() {
            if (!this.searchText || this.searchText.trim().length < 2) {
                this.autocompleteItems = [];
                return;
            }

            this.searchLoading = true;
            const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
            ProductoProvider.searchProductosByMarcaModelo(this.searchText.trim(), depositoId)
                .then(r => {
                    const productos = r.data && r.data.productoSearchByMarcaModelo
                        ? r.data.productoSearchByMarcaModelo
                        : [];
                    
                    this.autocompleteItems = productos.map(producto => ({
                        ...producto,
                        displayText: producto.nombre
                            ? producto.nombre
                            : `${producto.marca?.nombre || ''} ${producto.modelo?.nombre || ''}`.trim()
                    }));
                })
                .catch(err => {
                    console.error(err);
                    this.autocompleteItems = [];
                })
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        onProductoSelected(producto) {
            if (producto) {
                this.cantidadAgregadaItem = 0;
                this.item = producto;
                this.searchError = false;
                // Guardar el texto de búsqueda actual antes de que se limpie
                const textoActual = this.searchText || `${producto.marca.nombre} ${producto.modelo.nombre}`;
                this.lastSearchText = textoActual;
                this.save();
                // Limpiar la selección del autocomplete pero mantener el texto de búsqueda
                this.$nextTick(() => {
                    this.selectedProducto = null;
                    // Forzar la restauración del texto de búsqueda
                    this.searchText = textoActual;
                });
                // Asegurar que el texto se mantenga después de múltiples ciclos
                setTimeout(() => {
                    if (this.lastSearchText && !this.searchText) {
                        this.searchText = this.lastSearchText;
                    }
                }, 100);
            }
        },
        onAutocompleteInput(value) {
            // Si el usuario borra manualmente, limpiar también el item y el texto guardado
            if (!value || value === '') {
                // Solo limpiar si realmente el usuario lo borró (no estamos protegiendo)
                if (!this.isProtectingText) {
                    this.selectedProducto = null;
                    this.item = {};
                    this.lastSearchText = '';
                }
            } else {
                // Si el usuario está escribiendo, actualizar el texto guardado
                this.lastSearchText = value;
            }
        },
        agregarProducto() {
            if (this.item && this.item.id && (this.allowAddZeroStock || this.stockDisponibleEnCard > 0)) {
                this.$emit('addProductToCart', { producto: this.item, cantidad: 1 });
                this.cantidadAgregadaItem += 1;
                // Forzar que el texto de búsqueda se mantenga visible
                this.$nextTick(() => {
                    if (this.lastSearchText) {
                        this.searchText = this.lastSearchText;
                        this.selectedProducto = null;
                    }
                });
                // Doble verificación después de un pequeño delay
                setTimeout(() => {
                    if (this.lastSearchText && (!this.searchText || this.searchText === '')) {
                        this.searchText = this.lastSearchText;
                    }
                }, 50);
            }
        },
        cantidadDisabledMenos(item) {
            if (this.limitCantidadByStock && item.stock != null && Number(item.stock) < 1) return true;
            return (item.cantidad || 0) <= 1;
        },
        cantidadDisabledMas(item) {
            if (this.limitCantidadByStock && item.stock != null && Number(item.stock) < 1) return true;
            return this.limitCantidadByStock && (item.cantidad || 0) >= (item.stock != null ? Number(item.stock) : 0);
        },
        emitUpdateCantidad(item, newCantidad) {
            if (newCantidad < 1) {
                this.$emit('delete', item);
                return;
            }
            this.$emit('updateCantidad', { item, newCantidad });
        },
        soloNumeros(event) {
            const key = event.key;
            if (key === 'Backspace' || key === 'Tab' || key === 'Enter') return;
            if (!/^[0-9]$/.test(key)) event.preventDefault();
        },
        soloDecimales(event) {
            const key = event.key;
            if (key === 'Backspace' || key === 'Tab' || key === 'Enter' || key === 'ArrowLeft' || key === 'ArrowRight') return;
            const el = event.target;
            const value = el && el.value != null ? String(el.value) : '';
            if (key === '.' || key === ',') {
                if (value.includes('.') || value.includes(',')) event.preventDefault();
                return;
            }
            if (!/^[0-9]$/.test(key)) event.preventDefault();
        },
        formatPrecioInput(val) {
            const n = Number(val);
            if (!Number.isFinite(n)) return '0.00';
            return n.toFixed(2);
        },
        parsePrecioRaw(raw) {
            let s = '';
            if (raw != null && typeof raw === 'object') {
                if (raw.target && raw.target.value != null) {
                    s = String(raw.target.value);
                } else if (raw.value != null) {
                    s = String(raw.value);
                }
            } else if (raw != null) {
                s = String(raw);
            }
            const n = parseFloat(s.replace(',', '.').replace(/[^\d.]/g, ''));
            if (!Number.isFinite(n) || n < 0) return null;
            return Math.round(n * 100) / 100;
        },
        emitUpdatePrecio(item, newPrecio) {
            this.$emit('updatePrecio', { item, newPrecio });
        },
        onPrecioCommit(item, event) {
            clearTimeout(this.precioInputTimer);
            this.precioInputTimer = null;
            if (event && event.keyCode === 13 && event.target && event.target.blur) event.target.blur();
            const parsed = this.parsePrecioRaw(event);
            if (parsed == null) return;
            this.emitUpdatePrecio(item, parsed);
        },
        onCantidadInput(item, raw) {
            let s = "";
            if (raw != null && typeof raw === "object" && raw.target) {
                s = String(raw.target.value != null ? raw.target.value : "");
            } else if (raw != null) {
                s = String(raw);
            }
            clearTimeout(this.cantidadInputTimer);
            this.cantidadInputTimer = setTimeout(() => {
                this.cantidadInputTimer = null;
                const num = parseInt(s.replace(/\D/g, ""), 10);
                if (Number.isNaN(num)) return;
                if (num < 1) return;
                const max = this.limitCantidadByStock && item.stock != null ? Number(item.stock) : null;
                const final = max != null ? Math.min(num, max) : num;
                this.emitUpdateCantidad(item, final);
            }, 400);
        },
        onCantidadBlur(item, event) {
            clearTimeout(this.cantidadInputTimer);
            this.cantidadInputTimer = null;
            if (event && event.keyCode === 13 && event.target && event.target.blur) event.target.blur();
            const raw = event && event.target ? event.target.value : String(item.cantidad || "");
            const num = parseInt(raw, 10);
            if (isNaN(num) || num < 1) {
                this.$emit('updateCantidad', { item, newCantidad: item.cantidad || 1 });
                return;
            }
            const max = this.limitCantidadByStock && item.stock != null ? Number(item.stock) : null;
            const final = max != null ? Math.min(num, max) : num;
            this.$emit('updateCantidad', { item, newCantidad: final });
        },
        getOfertaDescripcion(ofertaAplicada) {
            if (!ofertaAplicada) return '';

            switch (ofertaAplicada.tipo) {
                case 'porcentaje':
                    return `${ofertaAplicada.valor}% OFF`;
                case 'por_cantidad':
                    return ofertaAplicada.valor != null
                        ? `${ofertaAplicada.valor}% OFF`
                        : 'Por cantidad';
                case '2x1':
                    return '2x1';
                case '3x2':
                    return '3x2';
                case '4x3':
                    return '4x3';
                default:
                    return 'Oferta';
            }
        }
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit('input', newVal)
            },
            deep: true
        },
        searchText: {
            handler(newVal) {
                // Si estamos protegiendo el texto, no hacer nada más
                if (this.isProtectingText) {
                    return;
                }
                
                // Si hay un texto guardado y un producto seleccionado, y el texto se borró,
                // restaurarlo (protección contra borrado automático)
                if (this.lastSearchText && this.item && this.item.id && (!newVal || newVal === '')) {
                    this.isProtectingText = true;
                    this.$nextTick(() => {
                        this.searchText = this.lastSearchText;
                        this.isProtectingText = false;
                    });
                    return;
                }
                
                // Si el usuario está escribiendo, actualizar el texto guardado
                if (newVal && newVal.trim().length > 0) {
                    this.lastSearchText = newVal;
                }
                
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
                
                if (newVal && newVal.trim().length >= 2) {
                    this.searchTimeout = setTimeout(() => {
                        this.searchProductos();
                    }, 500);
                } else if (!newVal || newVal === '') {
                    // Solo limpiar items si el usuario borró manualmente (no hay item seleccionado)
                    if (!this.item || !this.item.id) {
                        this.autocompleteItems = [];
                        this.lastSearchText = '';
                    }
                }
            },
            immediate: false
        },
    },
}
</script>

<style scoped>
.table-fixed-header-wrap {
    min-height: 0;
}
.product-search-dialog {
    border-radius: 12px;
    overflow: hidden;
}

.product-dialog-title {
    font-weight: 600;
    letter-spacing: 0.5px;
}

.product-dialog-card-text {
    padding-bottom: 8px !important;
}

.product-dialog-actions {
    padding-top: 8px !important;
}

.search-section {
    padding: 4px 0;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.7);
}

.section-title {
    font-size: 0.9rem;
    font-weight: 600;
}

.divider-text {
    padding: 0 12px;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: white;
}

.product-result-row {
    padding-top: 8px;
}

.search-result-alert {
    border-radius: 8px;
}

.product-result-card {
    border-radius: 10px;
    transition: box-shadow 0.2s ease;
}

.product-result-card:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.product-result-error {
    border-left: 4px solid #f44336;
}

.product-result-warning {
    border-left: 4px solid #ff9800;
}

.product-result-success {
    border-left: 4px solid #4caf50;
}

.product-result-title {
    font-size: 1rem;
    font-weight: 700;
}

.product-result-info {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px 8px;
}

.product-result-marca {
    font-size: 1.1rem;
    font-weight: 600;
}

.product-result-sep {
    color: rgba(0, 0, 0, 0.4);
    font-size: 1rem;
}

.product-result-modelo {
    font-size: 1.1rem;
    font-weight: 600;
}

.product-result-tamanio {
    font-size: 1rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.75);
}

.product-result-stock {
    font-size: 1.05rem;
    font-weight: 600;
    margin-top: 2px;
}

/* Estilos base del autocomplete (el menú se renderiza en portal, los estilos
   detallados van en el bloque .movimiento-compra-autocomplete-menu más abajo) */
.autocomplete-marca { font-weight: 600; }
.autocomplete-sep { color: rgba(0, 0, 0, 0.4); }
.autocomplete-modelo { font-weight: 600; }
.autocomplete-tamanio { font-weight: 500; color: rgba(0, 0, 0, 0.75); }

.product-list-table {
    border-radius: 8px;
    overflow: hidden;
}

.oferta-chip {
    animation: pulse 2s ease-in-out infinite;
    font-weight: 600;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

.cantidad-btn-square {
    min-width: 28px !important;
    min-height: 28px !important;
    width: 28px;
    height: 28px;
    border-radius: 4px !important;
    margin: 0 2px;
}

.cantidad-cell {
    width: 100%;
    justify-content: center;
}

.cantidad-input .v-input__slot input,
.cantidad-input input,
.cantidad-input.v-input input {
    text-align: center !important;
}

.precio-input .v-input__slot input,
.precio-input input,
.precio-input.v-input input {
    text-align: right !important;
}
</style>

<style lang="scss" scoped>
.cantidad-input ::v-deep input {
    text-align: center !important;
}
</style>

<style lang="scss">
.product-list-table.v-data-table {
    border-bottom: none !important;
}

/* Estilos para el menú del autocomplete (se renderiza en portal, fuera del componente).
   El primer ítem usa flex-direction: column por defecto en Vuetify; lo forzamos a row. */
.movimiento-compra-autocomplete-menu {
    .v-list-item {
        min-height: 48px !important;
        align-items: center !important;
    }
    .v-list-item__content {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        padding: 0 16px !important;
        align-items: center !important;
        overflow: visible !important;
        display: flex !important;
        flex-direction: row !important; /* Crítico: evita column en el 1er ítem */
    }
    .v-list-item:first-child .v-list-item__content,
    .v-list-item.v-list-item--highlighted .v-list-item__content {
        flex-direction: row !important;
    }
    .autocomplete-item-wrapper {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 0;
        min-height: 48px;
        font-size: 1rem !important;
        width: 100%;
    }
    .autocomplete-left {
        display: flex !important;
        align-items: baseline;
        flex-wrap: nowrap !important;
        gap: 4px 8px;
        min-width: 0;
        overflow: hidden;
    }
    .autocomplete-stock {
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        flex-shrink: 0 !important;
        white-space: nowrap;
    }
}
</style>
